import React, { PropTypes } from 'react';
import { inject, observer } from "mobx-react/index";
import { observable, action, toJS } from "mobx";
import moment from 'moment';
import alasql from "alasql";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { analysis as api, dataSeries} from "../../../actions/api";

import AnalysisDataViewGraph from "./AnalysisDataViewGraph";
import AnalysisDataViewTable from "./AnalysisDataViewTable";
import AnalysisDataDownload from "./AnalysisDataDownload";
import Spinner from "../../Spinner";
import Progress from "./Progress";
import { getDisplayDate } from "../../../libs/date";
import parameterTypeParser from "../../../libs/parameterTypeParser";
import { generalizedRecursiveFunction } from "../../../utils";
import { IconButton } from '../../Form';
import _ from 'lodash';

const style = {
  // position: 'fixed',
  // height: '100vh',
  // width: '100vw',
  background: '#fff',
  // top: 0,
  // left: 0,
  // overflowY: 'scroll'
};

@inject('stationStore', 'parameterStore')
@observer
class AnalysisDataView extends React.Component {
  mounted;

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  @observable dataSeriesItems = [];
  @observable analysisDataViewTable;
  @observable progress = null;
  @observable processing = false;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      expanded: {},
      hierData: [],
      data: [],
      selectedStations: {},
      selectedParameters: {},
      selectedView: 2,
      progress: null,
      stationParameterExpanded: {},
      parameterStationExpanded: {},
      stationParameterHeirData: [],
      parameterStationHeirData: [],
      showStationParameter: true,
      stationParameter1: [],
      stationParameter2: {},
      parameterStation1: [],
      parameterStation2: {},
    }
  }

  // last two args are optional
  @action
  processLargeArrayAsync = (array, fn, chunk, context) => {
    this.processing = true;

    return new Promise((resolve, reject) => {
      if (this.mounted) {
        context = context || window;
        chunk = chunk || 1000;
        var index = 0;

        const doChunk = () => {
          this.processing = true;

          if (this.mounted) {

            var cnt = chunk;
            while (cnt-- && index < array.length && this.mounted) {
              // callback called with args (value, index, array)
              fn.call(context, array[index], index, array);
              ++index;
            }
            if (index < array.length) {
              // set Timeout for async iteration
              setTimeout(doChunk, 1);
            } else {
              this.processing = false;
              resolve();
            }
          }
        };

        doChunk();
      }
    });
  }

  @action
  populateState = (data) => {
    return new Promise(async (resolve, reject) => {

      const { parameters, parameterStore, stationStore, period, func, aggregationType, missingTimestamps } = this.props;
      let stationParameter1 = [], parameterStation1 = [],
        stationParameter2 = {}, parameterStation2 = {}, format;

        const isPeriodSelected = period !== "" && period !== "None" && func && func.length > 0;  
      if (isPeriodSelected) {
        switch (period) {
          case "Annually":
            // format = 'YYYY-01-01 00:00:00';
            format = '01/01/YYYY 00:00:00';
            break;
          case "Monthly":
            // format = 'YYYY-MM-01 00:00:00';
            format = 'MM/01/YYYY 00:00:00';
            break;
          case "Daily":
            // format = 'YYYY-MM-DD 00:00:00';
            format = 'MM/DD/YYYY 00:00:00';
            break;
          case "Hourly":
            // format = 'YYYY-MM-DD HH:00:00';
            format = 'MM/DD/YYYY HH:00:00';
            break;
          default:
            // format = 'YYYY-MM-DD HH:mm:00';
            format = 'MM/DD/YYYY HH:mm:ss';
            break;
        }
      } else {
        // format = 'YYYY-MM-DD HH:mm:00';
        format = 'MM/DD/YYYY HH:mm:ss';
      }

      this.processing = true;

      this.processLargeArrayAsync(parameters, (parameter) => {
        parameterStation1.push({
          id: +parameter,
          level: 1,
          name: parameterStore.findById(parameter).name
        });
      });

      this.processLargeArrayAsync(data, async (station) => {
        stationParameter1.push({
          id: +station.id,
          name: station.name,
          // index: stationData && stationData.meta_data && stationData.meta_data.find(d => d.name === "Station Index") ? stationData.meta_data.find(d => d.name === "Station Index").value : '',
          level: 1
        });

        if (!!station.parameters && !!station.parameters.length) {
          _.map(station.parameters, async (parameter) => {
            if (!!parameter.data && !!parameter.data.length) {
              if (missingTimestamps) {
                const correspondingDataSeries = this.dataSeriesItems.find(i => +i.station_id === +station.id && +i.parameter_id === +parameter.parameter_id);
                // const correspondingDataSeries = { interval: 1 }
                if (correspondingDataSeries && correspondingDataSeries.interval) {
                  const max = Math.max.apply(Math, parameter.data.map((o) => new Date(o.time).getTime()));
                  let min = Math.min.apply(Math, parameter.data.map((o) => new Date(o.time).getTime()));
                  while (moment(min).isBefore(max)) {
                    if (!stationParameter2[station.id]) {
                      stationParameter2[station.id] = {};
                    }

                    const newStationParameterItem = {
                      level: 2,
                      id: parameter.parameter_id,
                      parent_id: +station.id,
                      time: getDisplayDate(min, { format })
                    };

                    if (func && func.length > 0) {
                      func.forEach(i => {
                        const fun = i.toLowerCase();

                        newStationParameterItem[fun] = {
                          [parameter.parameter_id]: ''
                        }
                      });
                    } else {
                      newStationParameterItem.data = {
                        [parameter.parameter_id]: ''
                      }
                    }

                    stationParameter2[station.id][getDisplayDate(min, { format })] = { ...newStationParameterItem };

                    if (!parameterStation2[parameter.parameter_id]) {
                      parameterStation2[parameter.parameter_id] = {};
                    }

                    const newParameterStationItem = {
                      level: 2,
                      id: station.id,
                      parent_id: +parameter.parameter_id,
                      time: getDisplayDate(min, { format })
                    };

                    if (func && func.length > 0) {
                      func.forEach(i => {
                        const fun = i.toLowerCase();

                        newParameterStationItem[fun] = {
                          [station.id]: ''
                        }
                      });
                    } else {
                      newParameterStationItem.data = {
                        [station.id]: ''
                      }
                    }
                    parameterStation2[parameter.parameter_id][getDisplayDate(min, { format })] = { ...newParameterStationItem };
                    min = moment(min).add(correspondingDataSeries.interval, 'minutes');
                  }
                }
              }

              _.map(parameter.data, (item) => {
                let time = getDisplayDate(item.time, { format });
                if (!stationParameter2[station.id]) stationParameter2 = Object.assign(stationParameter2, { [station.id]: {} });
                if (!parameterStation2[parameter.parameter_id]) parameterStation2 = Object.assign(parameterStation2, { [parameter.parameter_id]: {} });

                let parameterDetail = parameterStore.findById(parameter.parameter_id);

                if (aggregationType === 'right_closed_left_open') {
                  switch (period) {
                    case "Annually":
                      if (!(moment(time).month() === 0 && moment(time).date() === 1 && moment(time).month() === 0 && moment(time).hour() === 0 && moment(time).minute() === 0 && moment(time).second() === 0)) {
                        time = moment(time).add(1, 'years');
                      }

                      break;
                    case "Monthly":
                      if (!(moment(time).date() === 1 && moment(time).hour() === 0 && moment(time).minute() === 0 && moment(time).second() === 0)) {
                        time = moment(time).add(1, 'months');
                      }

                      break;
                    case "Daily":
                      if (!(moment(time).hour() === 0 && moment(time).minute() === 0 && moment(time).second() === 0)) {
                        time = moment(time).add(1, 'days');
                      }

                      break;
                    case "Hourly":
                      if (!(moment(time).minute() === 0 && moment(time).second() === 0)) {
                        time = moment(time).add(1, 'hours');
                      }

                      break;
                    default:
                      break;
                  }
                }

                let stationParameterDataItem = stationParameter2[station.id][time];
                let parameterStationDataItem = parameterStation2[parameter.parameter_id][time]

                if (!stationParameterDataItem) {
                  stationParameter2[station.id][time] = {
                    level: 2,
                    id: parameter.parameter_id,
                    parent_id: +station.id,
                    time,
                    ...(isPeriodSelected ?
                      func.reduce((acc, i) => {
                        const fun = i.toLowerCase();
                        if (fun === 'avg') acc['count'] = { [parameter.parameter_id]: 1 };
                        acc[fun] = {
                          [parameter.parameter_id]: parameterTypeParser(item.value, parameterDetail.property)
                        }
                        return acc;
                      }, {}) : {
                        data: {
                          [parameter.parameter_id]: parameterTypeParser(item.value, parameterDetail.property)
                        }
                      }
                    )
                  };
                } else {
                  if (period !== "" && period !== "None" && period && func && func.length > 0) {
                    func.forEach(i => {
                      const fun = i.toLowerCase();

                      const prevVal = stationParameterDataItem[fun][parameter.parameter_id];

                      if (prevVal || prevVal === 0) {
                        switch (fun) {
                          case 'min': {
                            const newVal = parameterTypeParser(item.value, parameterDetail.property);

                            if (newVal < prevVal)
                              stationParameterDataItem[fun][parameter.parameter_id] = newVal;

                            break;
                          }

                          case 'max': {
                            const newVal = parameterTypeParser(item.value, parameterDetail.property);

                            if (newVal > prevVal)
                              stationParameterDataItem[fun][parameter.parameter_id] = newVal;

                            break;
                          }

                          case 'avg': {
                            stationParameterDataItem[fun][parameter.parameter_id] = parameterTypeParser(item.value + prevVal, parameterDetail.property);
                            stationParameterDataItem['count'][parameter.parameter_id] = !stationParameterDataItem['count'][parameter.parameter_id] ? 2 : stationParameterDataItem['count'][parameter.parameter_id] + 1;

                            break;
                          }

                          case 'sum': {
                            stationParameterDataItem[fun][parameter.parameter_id] = parameterTypeParser(item.value + prevVal, parameterDetail.property);
                            break;
                          }

                          default:
                            break;
                        }
                      } else
                        stationParameterDataItem[fun][parameter.parameter_id] = parameterTypeParser(item.value, parameterDetail.property);
                    });
                  } else
                    stationParameterDataItem.data[parameter.parameter_id] = parameterTypeParser(item.value, parameterDetail.property);
                }

                if (!parameterStationDataItem) {
                  parameterStation2[parameter.parameter_id][time] = {
                    level: 2,
                    id: station.id,
                    parent_id: +parameter.parameter_id,
                    time:time,
                    ...(isPeriodSelected ?
                      func.reduce((acc, i) => {
                        const fun = i.toLowerCase();
                        if (fun === 'avg') acc['count'] = { [station.id]: 1 };
                        acc[fun] = {
                          [station.id]: parameterTypeParser(item.value, parameterDetail.property)
                        }
                        return acc;
                      }, {}) : {
                        data: {
                          [station.id]: parameterTypeParser(item.value, parameterDetail.property)
                        }
                      })
                  };
                } else {
                  if (isPeriodSelected) {
                    func.forEach(i => {
                      const fun = i.toLowerCase();

                      const prevVal = parameterStationDataItem[fun][station.id];

                      if (prevVal || prevVal === 0) {
                        switch (fun) {
                          case 'min': {
                            const newVal = parameterTypeParser(item.value, parameterDetail.property);

                            if (newVal < prevVal)
                              parameterStationDataItem[fun][station.id] = newVal;

                            break;
                          }

                          case 'max': {
                            const newVal = parameterTypeParser(item.value, parameterDetail.property);

                            if (newVal > prevVal)
                              parameterStationDataItem[fun][station.id] = newVal;

                            break;
                          }

                          case 'avg': {
                            parameterStationDataItem[fun][station.id] = parameterTypeParser(item.value + prevVal, parameterDetail.property);
                            parameterStationDataItem['count'][station.id] = !parameterStationDataItem['count'][station.id] ? 2 : parameterStationDataItem['count'][station.id] + 1;
                            break;
                          }

                          case 'sum': {
                            parameterStationDataItem[fun][station.id] = parameterTypeParser(item.value + prevVal, parameterDetail.property);
                            break;
                          }

                          default:
                            break;
                        }
                      } else
                        parameterStationDataItem[fun][station.id] = parameterTypeParser(item.value, parameterDetail.property);
                    });
                  } else
                  _.set(parameterStationDataItem, `data[${station.id}]`, parameterTypeParser(item.value, parameterDetail.property));
                }
              })
            }
          });
        }
      });

      if (isPeriodSelected && func.indexOf('Avg') > -1) {
        Object.keys(parameterStation2).forEach(parameterId => {
          Object.keys(parameterStation2[parameterId]).forEach(date => {
            Object.keys(parameterStation2[parameterId][date].avg).forEach(stationId => {
              let sum = parameterStation2[parameterId][date].avg[stationId];
              let count = parameterStation2[parameterId][date].count[stationId];
              if (!!sum && !!count) {
                parameterStation2[parameterId][date].avg[stationId] = Math.floor(sum / count * 1000) / 1000;
                // parameterStation2[parameterId][date].count[stationId] = 1;
              }
            });
          })
        })
        Object.keys(stationParameter2).forEach(stationId => {
          Object.keys(stationParameter2[stationId]).forEach(date => {
            Object.keys(stationParameter2[stationId][date].avg).forEach(parameterId => {
              let sum = stationParameter2[stationId][date].avg[parameterId];
              let count = stationParameter2[stationId][date].count[parameterId];
              if (!!sum && !!count) {
                stationParameter2[stationId][date].avg[parameterId] = Math.floor(sum / count * 1000) / 1000;
                // stationParameter2[stationId][date].count[parameterId] = 1;
              }
            });
          })
        })
      }

      this.setState({
        stationParameter1, stationParameter2,
        parameterStation1, parameterStation2,
      }, () => {
        resolve();
        this.processing = false;
      })
    });
  };

  flattenData = () => {
    const { parameterStation2} = this.state;
    const { period, func } = this.props;
    let format

    if (period && period !== '' && period !== "None" && func && func.length > 0) {
      switch (period) {
        case "Annually":
          // format = 'YYYY-01-01 00:00:00';
          format = '01/01/YYYY 00:00:00';
          break;
        case "Monthly":
          // format = 'YYYY-MM-01 00:00:00';
          format = 'MM/01/YYYY 00:00:00';
          break;
        case "Daily":
          // format = 'YYYY-MM-DD 00:00:00';
          format = 'MM/DD/YYYY 00:00:00';
          break;
        case "Hourly":
          // format = 'YYYY-MM-DD HH:00:00';
          format = 'MM/DD/YYYY HH:00:00';
          break;
        default:
          // format = 'YYYY-MM-DD HH:mm:00';
          format = 'MM/DD/YYYY HH:mm:00';
          break;
      }
    } else {
      // format = 'YYYY-MM-DD HH:mm:00';
      format = 'MM/DD/YYYY HH:mm:00';
    }

    let flattenedArray = [];
    let keysToExtract = ['avg', 'max', 'sum', 'min'];

    for (let key in parameterStation2) {
      if (parameterStation2.hasOwnProperty(key)) {
        let innerObject = parameterStation2[key];

        for (let dateKey in innerObject) {
          if (innerObject.hasOwnProperty(dateKey)) {
            let innermostObject = innerObject[dateKey];

            let copiedObject = { ...innermostObject };

            let extractedObjects = {};

            keysToExtract.forEach((extractKey) => {
              if (copiedObject.hasOwnProperty(extractKey)) {
                for (let id in copiedObject[extractKey]) {
                  if (copiedObject[extractKey].hasOwnProperty(id)) {
                    let value = copiedObject[extractKey][id];

                    if (!extractedObjects[id]) {
                      extractedObjects[id] = { id: id, dateKey:dateKey };
                    }

                    extractedObjects[id][`${extractKey}`] = value;
                  }
                }
                delete copiedObject[extractKey];
              }
            });

            for (let id in extractedObjects) {
              if (extractedObjects.hasOwnProperty(id)) {
                let flattenedObject = {
                  ...copiedObject,
                  ...extractedObjects[id]
                };
                flattenedArray.push(flattenedObject);
              }
            }
          }
        }
      }
    }

    flattenedArray.forEach(item => {
      const station = this.state.data.find(station => station.id === item.id);
      if (!station) return;
    
      const parameter = station.parameters.find(param => param.parameter_id === item.parent_id);
      if (!parameter) return;
    
      parameter.data2 = parameter.data2 || [];
    
      const { avg, min, max, sum, time } = item;
      if (avg !== undefined || min !== undefined || max !== undefined || sum !== undefined) {
        const filteredData = { time, ...(avg !== undefined && { avg }), ...(min !== undefined && { min }), ...(max !== undefined && { max }), ...(sum !== undefined && { sum }) };
        parameter.data2.push(filteredData);
      }
    });
    
  }

  downloadHierData = () => {
    const { stations, parameters, parameterStore, stationStore, func, missingTimestamps } = this.props;
    const { showStationParameter, stationParameter1, stationParameter2, parameterStation1, parameterStation2, data } = this.state;

    func.sort((a, b) => {
      if (a > b)
        return 1;
      else if (a < b)
        return -1;
      else
        return 0;
    });

    // eslint-disable-next-line
    const getSheetName = name => name.split('').slice(0, 30).join('').replace(/[\[\]\\/*?]/g, '');

    let dataArray = [],
      sheets = [];
    if (!showStationParameter) sheets = parameters.map(item => {
      let parameter = parameterStore.findById(item);
      return ({ sheetid: getSheetName(parameter.name) })
    });
    else sheets = data.map(item => ({ sheetid: getSheetName(item.name) }));

    // let heirData = showStationParameter ? stationParameterHeirData : parameterStationHeirData;
    let level1Data = showStationParameter ? stationParameter1 : parameterStation1;
    let level2Data = showStationParameter ? stationParameter2 : parameterStation2;

    level1Data.forEach(l1_item => {
      let l2_items = level2Data[l1_item.id];

      let stationId = l2_items && l2_items != undefined && Object.values(l2_items)[0].parent_id
      let parameter_id = l2_items && l2_items != undefined && Object.values(l2_items)[0].id
      let stationData = data && data.find((i ) => i.id == stationId)
      let seriesId = stationData && stationData.parameters.find ((i) => i.parameter_id == parameter_id).series_id
      
       if (!!missingTimestamps)l2_items =  l2_items && this.insertMissingTimeStampDownload(l2_items, seriesId)

      if (!l2_items || Object.keys(l2_items).length === 0) {
        let rowObj = {
          Time: ''
        };

        (showStationParameter ? parameters : stations).map(item => {
          if (func.length > 0) {
            func.forEach(i => {
              const fun = i.toLowerCase();

              rowObj = Object.assign(rowObj, {
                [(showStationParameter ? parameterStore : stationStore).findById(item).name + `(${i})`]: ''
              });
            });
          } else {
            rowObj = Object.assign(rowObj, {
              [(showStationParameter ? parameterStore : stationStore).findById(item).name]: ''
            });
          }
        });

        dataArray.push([rowObj])
      } else dataArray.push(Object.keys(l2_items).sort((a, b) => new Date(a).valueOf() < new Date(b).valueOf() ? -1 : 1).map(key => {
        let l2_item = l2_items[key];
        let rowObj = {
          Time: l2_item.time
        };

        (showStationParameter ? parameters : stations).map(item => {
          if (func.length > 0) {
            func.forEach(i => {
              const fun = i.toLowerCase();

              rowObj = Object.assign(rowObj, {
                [(showStationParameter ? parameterStore : stationStore).findById(item).name + `(${i})`]: !!l2_item[fun][item] || l2_item[fun][item] === 0 ? l2_item[fun][item] : ''
              })
            });
          } else {
            rowObj = Object.assign(rowObj, {
              [(showStationParameter ? parameterStore : stationStore).findById(item).name]: !!l2_item.data[item] || l2_item.data[item] === 0 ? l2_item.data[item] : ''
            })
          }
        });

        return rowObj

      }));
    });

    dataArray = dataArray.map(item => {
      if (Array.isArray(item)){
        let data = item && item.map((i) => {
          if (i.Time && moment(i.Time, 'MM/DD/YYYY HH:mm:ss', true).isValid()) {
            i.Time = moment(i.Time, 'MM/DD/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
        }
        return i;
        })
        return data;
      }
     
      return item
  }); 


    alasql('SELECT INTO XLSX("AnalysisData.xlsx",?) FROM ?', [sheets, dataArray]);
  };

  downloadDefaultHierData = (e) => {
    e.preventDefault();
    const { stations, parameters, parameterStore, stationStore, func, missingTimestamps } = this.props;
    const { stationParameter1, stationParameter2, parameterStation1, parameterStation2, data } = this.state;

    func.sort((a, b) => {
      if (a > b)
        return 1;
      else if (a < b)
        return -1;
      else
        return 0;
    });

    // eslint-disable-next-line
    const getSheetName = name => name.split('').slice(0, 30).join('').replace(/[\[\]\\/*?]/g, '');

    let dataArray = [],
      sheets = [];

    sheets = data.map(item => ({ sheetid: getSheetName(item.name) }));

    let level1Data = stationParameter1;
    let level2Data = stationParameter2;

    level1Data.forEach(l1_item => {
      let l2_items = level2Data[l1_item.id];

      let stationId = l2_items && l2_items != undefined && Object.values(l2_items)[0].parent_id
      let parameter_id = l2_items && l2_items != undefined && Object.values(l2_items)[0].id
      let stationData = data && data.find((i ) => i.id == stationId)
      let seriesId = stationData && stationData.parameters.find ((i) => i.parameter_id == parameter_id).series_id
      
       if (!!missingTimestamps)l2_items =  l2_items && this.insertMissingTimeStampDownload(l2_items, seriesId)

      if (!l2_items || Object.keys(l2_items).length === 0) {
        let rowObj = {
          Time: ''
        };

        (parameters).map(item => {
          if (func.length > 0) {
            func.forEach(i => {
              const fun = i.toLowerCase();

              rowObj = Object.assign(rowObj, {
                [(parameterStore).findById(item).name + `(${i})`]: ''
              })
            });
          } else {
            rowObj = Object.assign(rowObj, {
              [(parameterStore).findById(item).name]: ''
            })
          }
        });

        dataArray.push([rowObj])
      } else dataArray.push(Object.keys(l2_items).sort((a, b) => new Date(a).valueOf() < new Date(b).valueOf() ? -1 : 1).map(key => {
        let l2_item = l2_items[key];
        let rowObj = {
          Time: l2_item.time
        };

        (parameters).map(item => {
          if (func.length > 0) {
            func.forEach(i => {
              const fun = i.toLowerCase();

              rowObj = Object.assign(rowObj, {
                [(parameterStore).findById(item).name + `(${i})`]: !!l2_item[fun][item] || l2_item[fun][item] === 0 ? l2_item[fun][item] : ''
              })
            });
          } else {
            rowObj = Object.assign(rowObj, {
              [(parameterStore).findById(item).name]: !!l2_item.data[item] || l2_item.data[item] === 0 ? l2_item.data[item] : ''
            })
          }
        });

        return rowObj

      }));
    });

    dataArray = dataArray.map(item => {
      if (Array.isArray(item)){
        let data = item && item.map((i) => {
          if (i.Time && moment(i.Time, 'MM/DD/YYYY HH:mm:ss', true).isValid()) {
            i.Time = moment(i.Time, 'MM/DD/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
        }
        return i;
        })
        return data;
      }
     
      return item
  }); 

    alasql('SELECT INTO XLSX("AnalysisData.xlsx",?) FROM ?', [sheets, dataArray]);
  };

  insertMissingTimeStampDownload(data,seriesId) {
    const {func} = this.props;
    const result = {};
    const stationKeys = Object.keys(data).sort((a, b) => new Date(a) - new Date(b)); 
    const sampleStructure = data[stationKeys[0]];
    const stationId = sampleStructure.parent_id;
    const dataSeries = this.dataSeriesItems.find(item => item.id === seriesId );
    let interval = dataSeries && dataSeries.interval

    if (!interval) return data

    let currentTime = new Date(stationKeys[0]);
    const endTime = new Date(stationKeys[stationKeys.length - 1]);

    result[stationId] = {};
    while (currentTime <= endTime) {
        const timeString = moment(currentTime).format('MM/DD/YYYY HH:mm:ss');
        if (func && func.length > 0) {
          func.forEach((item) => {
            let dataKey = item.toLowerCase();    
            result[stationId][timeString] = result[stationId][timeString] || {...sampleStructure,time:timeString}

            if (!data[timeString]){
              result[stationId][timeString][dataKey] = Object.keys(sampleStructure[dataKey]).reduce((acc,key) => {
                acc[key] = null
                return acc
              },{})
            }

          });
        }
        else {
          result[stationId][timeString] = data[timeString] || {
            ...sampleStructure,
            time: timeString,
            data: Object.keys(sampleStructure.data).reduce((acc, key) => {
                acc[key] = null;
                return acc;
            }, {})
        };
        }

    
        
        currentTime.setMinutes(currentTime.getMinutes() + interval);
    }

    return result[stationId];
}

  downloadCSVData = (format) => {
    const { stations, parameters, parameterStore, stationStore, func , missingTimestamps} = this.props;
    const { stationParameter1, stationParameter2, parameterStation1, parameterStation2, data } = this.state;
    func.sort((a, b) => {
      if (a > b)
        return 1;
      else if (a < b)
        return -1;
      else
        return 0;
    });

    parameters.sort((a, b) => {
      const aParam = parameterStore.findById(a), bParam = parameterStore.findById(b);
      return `${aParam.code} (${aParam.parameter_unit_symbol})` > `${bParam.code} (${bParam.parameter_unit_symbol})`;
      // if (`${aParam.code} (${aParam.parameter_unit_symbol})` > `${bParam.code} (${bParam.parameter_unit_symbol})`)
      //   return 1;
      // else if (`${aParam.code} (${aParam.parameter_unit_symbol})` < `${bParam.code} (${bParam.parameter_unit_symbol})`)
      //   return -1;
      // else
      //   return 0;
    });

    let level1Data = stationParameter1.sort((a, b) => {
      if (a.name > b.name)
        return 1;
      else if (a.name < b.name)
        return -1;
      else
        return 0;
    });

    let level2Data = stationParameter2;

    const indexArr = level1Data.map(item => item.id);

    let dataArray;

    if (func && func.length > 0) {
      dataArray = [["Time",
        ...level1Data
          .map(d => parameters.map(item => func.map(i => `${d.name} ${parameterStore.findById(item).code} (${parameterStore.findById(item).parameter_unit_symbol}) (${i})`)).reduce((acc, val) => [...val, ...acc]))
          .reduce((acc, val) => [...val, ...acc])
          .sort((a, b) => {
            if (a > b)
              return 1;
            else if (a < b)
              return -1;
            else
              return 0;
          })
      ]];
    } else {
      dataArray = [["Time",
        ...level1Data
          .map(d => parameters.map(item => `${d.name} ${parameterStore.findById(item).code} (${parameterStore.findById(item).parameter_unit_symbol})`))
          .reduce((acc, val) => [...val, ...acc])
          .sort((a, b) => {
            if (a > b)
              return 1;
            else if (a < b)
              return -1;
            else
              return 0;
          })
      ]];
    }

    level1Data.forEach(station => {
      let dateData = level2Data[station.id];

      let stationId = dateData && dateData != undefined && Object.values(dateData)[0].parent_id
      let parameter_id = dateData && dateData != undefined && Object.values(dateData)[0].id
      let stationData = data && data.find((i ) => i.id == stationId)
      let seriesId = stationData && stationData.parameters.find ((i) => i.parameter_id == parameter_id).series_id
      
       if (!!missingTimestamps)dateData =  dateData && this.insertMissingTimeStampDownload(dateData, seriesId)
      if (dateData) {

        Object.keys(dateData).forEach(key => {
          const existingDateData = dataArray.find(data => data[0] === key);

          if (!existingDateData) {
            const rowObj = [key];

            indexArr.forEach((id) => {
              const stationDateData = level2Data[id];
              if (stationDateData && stationDateData[key]) {
                const l2_item = stationDateData[key];

                (parameters).forEach(item => {
                  if (func && func.length > 0) {
                    func.forEach(i => {
                      const fun = i.toLowerCase();

                      if (l2_item && l2_item[fun])
                        rowObj.push(!!l2_item[fun][item] || l2_item[fun][item] === 0 ? l2_item[fun][item] : '');
                      else
                        rowObj.push('');
                    });
                  } else {
                    if (l2_item && l2_item.data) {
                      rowObj.push(!!l2_item.data[item] || l2_item.data[item] === 0 ? l2_item.data[item] : '');
                    }
                    else
                      rowObj.push('');
                  }
                });
              } else {
                (parameters).forEach(() => {
                  if (func && func.length > 0) {
                    func.forEach(i => {
                      rowObj.push('');
                    });
                  } else {
                    rowObj.push('');
                  }
                });
              }
            });

            dataArray.push(rowObj);
          }
        });
      }
    });

    dataArray.sort((a, b) => new Date(a[0]).getTime() - new Date(b[0]).getTime());
    dataArray = dataArray && dataArray.map(item => {
      if (item && item[0] && moment(item[0], 'MM/DD/YYYY HH:mm:ss', true).isValid()) {
          item[0] = moment(item[0], 'MM/DD/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
      }
  
      return item;
  }); 


    if (format === "CSV") {
      alasql(`SELECT * INTO CSV('AnalysisData.csv',{separator:",", headers: false}) FROM ?`, [
        dataArray
      ]);
    } else if (format === "PDF") {
      let numOfCols = 7;
      let header = dataArray.shift();
      let doc = new jsPDF({
        orientation: "landscape",
      });
      for (let i = 1; i < header.length; i += numOfCols) {
        doc.autoTable({
          head: [[header[0], ...header.slice(i, i + numOfCols)]],
          body: dataArray.map(line => [line[0], ...line.slice(i, i + numOfCols)]),
          pageBreak: 'always'
        })
      }
      // doc.autoTable({
      //   head: [header],
      //   body: dataArray,
      // })
      doc.deletePage(1);
      doc.save('AnalysisData.pdf')
    }
  }

  @action
  recursiveFetchByDate = ({ date_from, date_to, stations, parameters, targetProgress }) => {
    if (this.mounted) {
      const twoWeeksLater = moment(date_from).add(1, 'week')

      return this.recursiveSplitByParameterLength({
        stations,
        parameters,
        date_from,
        date_to: twoWeeksLater,
        targetProgress
      }).then(async res => {
        try {
          if (twoWeeksLater.isBefore(date_to)) {
            const more = await this.recursiveFetchByDate({
              date_from: twoWeeksLater,
              date_to,
              stations,
              parameters,
              targetProgress
            });

            return [...res, ...more];
          } else
            return res;
        } catch (e) {
          throw (new Error(e.message));
        }
      });
    } else {
      return Promise.resolve();
    }
  };

  @action
  recursiveSplitByParameterLength = ({ date_from, date_to, stations, parameters, targetProgress }) => {
    if (this.mounted) {
      return this.recursiveSplitByStationLength({
        stations,
        parameters: parameters.slice(0, 5),
        date_from,
        date_to,
        targetProgress
      }).then(async res => {
        try {
          if (parameters.slice(5, parameters.length).length > 0) {
            const more = await this.recursiveSplitByParameterLength({
              date_from,
              date_to,
              parameters: parameters.slice(5, parameters.length),
              stations,
              targetProgress
            });

            return [...res, ...more];
          } else {
            return res;
          }
        } catch (e) {
          throw (new Error(e.message));
        }
      });
    } else {
      return Promise.resolve();
    }
  };

  @action
  recursiveSplitByStationLength = ({ date_from, date_to, stations, parameters, targetProgress }) => {
    if (this.mounted) {
      return api.fetchMore({
        stations: stations.slice(0, 4).join(','),
        parameters: parameters.join(','),
        date_from: getDisplayDate(date_from, { format: 'YYYY-MM-DDTHH:mm:ss' }),
        date_to: getDisplayDate(date_to, { format: 'YYYY-MM-DDTHH:mm:ss' })
      }).then(async res => {
        try {
          this.progress = this.progress + (100 / targetProgress);

          if (stations.slice(4, stations.length).length > 0) {
            const more = await this.recursiveSplitByStationLength({
              date_from,
              date_to,
              stations: stations.slice(4, stations.length),
              parameters,
              targetProgress
            });

            return [...res, ...more];
          } else {
            return res;
          }
        } catch (e) {
          console.trace(e);

          throw (new Error(e.message));
        }
      }).catch(async e => {
        console.trace(e);

        throw (new Error(e.message));
      });
    } else {
      return Promise.resolve();
    }
  }

  async componentWillMount() {
    this.mounted = true;

    const { stations, parameters, from, to, parameterStore } = this.props;
    if (!stations.length || !parameters.length || !from || !to) {
      this.onCloseView();
      return;
    }
    let expanded = {}, selectedStations = {}, selectedParameters = {};

    stations.forEach(item => Object.assign(selectedStations, { [+item]: true }));
    parameters.forEach(item => Object.assign(selectedParameters, { [+item]: true }));

    this.setState({ isLoading: true });

    let date_from = moment(from);
    const date_to = moment(to);

    const differenceInWeeks = date_to.diff(date_from, 'weeks');
    const differenceInDays = date_to.diff(date_from, 'days');

    this.progress = 0;
    let targetProgress;

    if (+differenceInWeeks >= 4) {
      targetProgress = Math.ceil(stations.length / 4) * Math.ceil(differenceInDays / 7) * Math.ceil(parameters.length / 4);
    } else {
      targetProgress = Math.ceil(stations.length / 4) * Math.ceil(parameters.length / 4);
    }

    dataSeries.fetchAll()
      .then(action(dataSeriesItems => {
        this.dataSeriesItems = dataSeriesItems
          .sort((a, b) => a.name > b.name ? 1 : -1)
          .map(item => (Object.assign(item, { parameter: parameterStore.findById(item.parameter_id) })));
        generalizedRecursiveFunction({
          fun: api.fetchMore,
          relevantParameters: {
            stations,
            parameters
          },
          date_from: from,
          date_to: to,
          updateProgress: () => {
            this.progress += (100 / targetProgress);
          }
        }).then(allRes => {
          this.progress = 100;

          this.setState({
            expanded,
            selectedStations,
            selectedParameters,
            data: allRes.reduce((acc, res) => {
              const newAcc = [...acc];
              [res].forEach(value => {
                const existingStation = newAcc.find(a => +a.id === +value.id);
                if (existingStation) {
                  if (value.parameters) {
                    if (existingStation.parameters) {
                      value.parameters.forEach(parameter => {
                        const existingParameter = existingStation.parameters.find(p => +p.parameter_id === +parameter.parameter_id);
                        if (existingParameter) {
                          if (existingParameter.data && parameter.data) {
                            existingParameter.data = [...existingParameter.data, ...parameter.data];
                          } else if (parameter.data) {
                            existingParameter.data = parameter.data;
                          }
                        } else {
                          existingStation.parameters.push(parameter);
                        }
                      });
                    } else {
                      existingStation.parameters = value.parameters;
                    }
                  }
                } else {
                  newAcc.push(value);
                }
              });
              return newAcc;
            }, []),
          }, () => {
            this.progress = null;
            this.populateState(this.state.data).then(() => {
              this.flattenData()
              this.setState({ isLoading: false });
            });
          })
        }).catch(err => {
          console.log(err);
          this.setState({ isLoading: false });
          this.progress = null;

          alert('Request Timed Out');
          this.context.router.push('/analysis/data')
        });
      }));
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onCloseView = () => {
    this.context.router.push('/analysis/data')
  };

  onClickExpandCollapse = (id) => {
    if (this.state.showStationParameter) {
      let stationParameterExpanded = Object.assign({}, this.state.stationParameterExpanded, { [id]: !this.state.stationParameterExpanded[id] });
      this.setState({ stationParameterExpanded })
    } else {
      let parameterStationExpanded = Object.assign({}, this.state.parameterStationExpanded, { [id]: !this.state.parameterStationExpanded[id] });
      this.setState({ parameterStationExpanded })
    }
  };

  onChangeSelectedStations = (ids, value) => {
    if (typeof ids === 'object') {
      let selectedStations = Object.assign({}, this.state.selectedStations);
      ids.forEach(id => Object.assign(selectedStations, { [+id]: value }));
      this.setState({ selectedStations });
    } else {
      let selectedStations = Object.assign({}, this.state.selectedStations, { [+ids]: !this.state.selectedStations[+ids] });
      this.setState({ selectedStations });
    }
  };

  onChangeSelectedParameter = (ids, value) => {
    if (typeof ids === 'object') {
      let selectedParameters = Object.assign({}, this.state.selectedParameters);
      ids.forEach(id => Object.assign(selectedParameters, { [+id]: value }));
      this.setState({ selectedParameters });
    } else {
      let selectedParameters = Object.assign({}, this.state.selectedParameters, { [+ids]: !this.state.selectedParameters[+ids] });
      this.setState({ selectedParameters });
    }
  };

  _renderRow = rowData => {
    if (rowData.level > 1 && !this.state.stationParameterExpanded[rowData.parent_id]) return null;
    const { stations, parameters, selectedStations, selectedParameters, onChangeSelectedStations, onChangeSelectedParameter, parameterStore } = this.props;
    const { showStationParameter } = this.state;

    const caretDown = rowData.level === 1 &&
      this.state.stationParameterExpanded[rowData.id];
    const caretRight = rowData.level === 1 &&
      !this.state.stationParameterExpanded[rowData.id];

    const onClickExpandCollapse = () => {
      let stationParameterExpanded = Object.assign({}, this.state.stationParameterExpanded, { [rowData.id]: !this.state.stationParameterExpanded[rowData.id] });
      this.setState({ stationParameterExpanded })
    };

    return (
      <tr
        key={`analysis-table-row-station-${rowData.level > 1 ? `${rowData.parent_id}-parameter-${rowData.id}-time-${rowData.time}` : rowData.id}`}>
        <th className="caret" style={{ width: '20px', marginTop: '2px' }} onClick={onClickExpandCollapse}>
          {(caretDown === true) && (
            <i className="fa fa-caret-down" aria-hidden="true" />
          )}
          {(caretRight === true) && (
            <i className="fa fa-caret-right" aria-hidden="true" />
          )}
        </th>
        <th style={{ left: '30px', width: '200px' }}>{
          rowData.level === 1 ?
            showStationParameter ?
              <div style={{ fontWeight: 'bold' }}><input type='checkbox' checked={selectedStations[rowData.id]}
                onChange={() => onChangeSelectedStations(rowData.id)}
                style={{ margin: '10px' }} />{rowData.name}</div> :
              <div style={{ fontWeight: 'bold' }}><input type='checkbox' checked={selectedParameters[rowData.id]}
                onChange={() => onChangeSelectedParameter(rowData.id)}
                style={{ margin: '10px' }} />{rowData.name}</div> :
            rowData.time
        }</th>
        {/*<td style={{width: '160px'}}>{rowData.level === 2 && getDisplayDate(rowData.time)}</td>*/}
        {showStationParameter ?
          parameters.map(parameter => <td key={`analysis-table-parameter-${parameter}-value`}>
            <div style={{ width: '60px', textAlign: 'center' }}>{rowData.level === 2 && rowData.data[parameter]}</div>
          </td>) :
          stations.map(station => <td key={`analysis-table-station-${station}-value`}>
            <div style={{ width: '130px', textAlign: 'center' }}>{rowData.level === 2 && rowData.data[station]}</div>
          </td>)
        }
      </tr>
    )
  };

  render() {
    const {
      selectedView,
      stationParameter1,
      stationParameter2,
      parameterStation1,
      parameterStation2
    } = this.state;

    const { stationStore, parameterStore, stations, parameters, func, missingTimestamps } = this.props;
    if (stationStore.items.length === 0 || parameterStore.items.length === 0) return null;

    // if (this.dataSeriesItems.length === 0) return null;

    if (this.state.isLoading) {
      return <div style={style}>
        <i className='fa fa-arrow-left' style={{ position: 'relative', float: 'left' }} onClick={this.onCloseView} />
        <Spinner />
        {this.progress !== null ? <Progress progress={this.progress} /> : null}
      </div>
    }

    return (
      <div style={style}>
        <div className='inline-grid v-center'>
          <IconButton icon='fa fa-arrow-left' onClick={this.onCloseView} />
          <span className='flex-grow' />
          <div className='flex flex-row v-center'>
            {selectedView === 1 && <IconButton icon='fa fa-download' onClick={this.downloadHierData} data-toggle="tooltip" title='Download CSV' />}
            <div className={`ticket-action-button ${selectedView === 0 ? 'primary' : ''} tab-button-left`} onClick={() => this.setState({ selectedView: 0 })}>
              <i className='fa fa-bar-chart' />
              Graph
            </div>
            <div className={`ticket-action-button ${selectedView === 1 ? 'primary' : ''} tab-button-center`} onClick={() => this.setState({ selectedView: 1 })}>
              <i className='fa fa-table' />
              Table
            </div>
            <div className={`ticket-action-button ${selectedView === 2 ? 'primary' : ''} tab-button-right`} onClick={() => this.setState({ selectedView: 2 })}>
              <i className='fa fa-table' />
              Export
            </div>
          </div>
        </div>
        {selectedView === 0 ?
          <AnalysisDataViewGraph
            data={this.state.data}
            selectedStations={this.state.selectedStations}
            selectedParameters={this.state.selectedParameters}
            missingTimestamps={missingTimestamps}
            dataSeriesItems={this.dataSeriesItems}
          /> :
          selectedView === 1 ? <AnalysisDataViewTable ref={el => this.analysisDataViewTable = el}
            onClickExpandCollapse={this.onClickExpandCollapse}
            stations={stations}
            parameters={parameters}
            func={func}
            setShowStationParameter={(showStationParameter) => this.setState({ showStationParameter })}
            {...this.state}
            onChangeSelectedStations={this.onChangeSelectedStations}
            onChangeSelectedParameter={this.onChangeSelectedParameter} /> :
            selectedView === 2 ? <AnalysisDataDownload
              // data={this.state.data}
              ready={!this.processing}
              downloadCSVData={this.downloadCSVData}
              downloadHierData={this.downloadDefaultHierData}
              downloadPdfData={this.downloadPdfData}
            // stationParameter1={stationParameter1}
            // stationParameter2={stationParameter2}
            // parameterStation1={parameterStation1}
            // parameterStation2={parameterStation2}
            // stations={stations}
            // parameters={parameters}
            /> : null}
      </div>
    );
  }
}

export default AnalysisDataView;



// WEBPACK FOOTER //
// ./src/components/Analysis/Data/AnalysisDataView.js